var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.8907 19.1026L8.52184 15.9453C8.72069 18.3281 9.47563 20.9572 11.0343 23.812L7.7843 26.412L8.15672 26.8775L7.7843 26.412C7.75115 26.4386 7.71179 26.4562 7.66994 26.4633C7.62808 26.4704 7.5851 26.4667 7.54506 26.4526C7.50502 26.4385 7.46923 26.4144 7.44106 26.3827C7.4129 26.3509 7.39329 26.3125 7.38408 26.271L7.38408 26.271L5.83873 19.3169L5.83872 19.3169C5.83043 19.2796 5.8308 19.2409 5.83981 19.2037C5.84882 19.1666 5.86623 19.132 5.8907 19.1026L5.8907 19.1026Z",
    fill: "#4C7889",
    stroke: "#4C7889",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.8905 23.7217C22.4492 20.8669 23.2041 18.2378 23.403 15.8549L26.0341 19.0123L26.0341 19.0123C26.0586 19.0417 26.076 19.0762 26.085 19.1134C26.094 19.1505 26.0944 19.1892 26.0861 19.2265L26.0861 19.2266L24.5407 26.1807L24.5407 26.1807C24.5315 26.2222 24.5119 26.2606 24.4837 26.2923C24.4556 26.3241 24.4198 26.3482 24.3797 26.3623C24.3397 26.3764 24.2967 26.3801 24.2549 26.373C24.213 26.3659 24.1736 26.3482 24.1405 26.3217L20.8905 23.7217Z",
    fill: "#4C7889",
    stroke: "#4C7889",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H14",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3714 2.47053C12.9974 4.3723 5.05688 11.9717 12.0001 24.0002H20.0001C26.7989 11.9802 18.9746 4.38305 16.6255 2.47458C16.4484 2.33063 16.2273 2.25172 15.9991 2.25098C15.771 2.25025 15.5494 2.32773 15.3714 2.47053V2.47053Z",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23331 13.9199L5.31454 18.6225C5.21666 18.7399 5.14701 18.8783 5.11096 19.0268C5.07491 19.1754 5.07341 19.3303 5.10658 19.4796L6.65194 26.4337C6.68878 26.5995 6.76723 26.7531 6.87988 26.8802C6.99254 27.0073 7.13571 27.1035 7.29587 27.16C7.45604 27.2164 7.62794 27.2311 7.79536 27.2027C7.96279 27.1743 8.12022 27.1037 8.25282 26.9976L12 23.9999",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6914 13.8296L26.6854 18.6224C26.7833 18.7399 26.853 18.8782 26.889 19.0268C26.9251 19.1754 26.9266 19.3303 26.8934 19.4795L25.348 26.4337C25.3112 26.5994 25.2328 26.7531 25.1201 26.8802C25.0074 27.0072 24.8643 27.1035 24.7041 27.1599C24.5439 27.2163 24.372 27.2311 24.2046 27.2027C24.0372 27.1743 23.8798 27.1037 23.7472 26.9976L20 23.9999",
    stroke: "#4C7889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5C16.8284 13.5 17.5 12.8284 17.5 12C17.5 11.1716 16.8284 10.5 16 10.5C15.1716 10.5 14.5 11.1716 14.5 12C14.5 12.8284 15.1716 13.5 16 13.5Z",
    fill: "#4C7889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.be216ed5e52106f34dfeab71ef8a9071.svg";
export { ForwardRef as ReactComponent };